import React from 'react';
import './Footer.css';
const Footer = () => {
  return (
    <div>
      <footer>
        <div class="waves">
            <div class="wave" id="wave1"></div>
            <div class="wave" id="wave2"></div>
            <div class="wave" id="wave3"></div>
            <div class="wave" id="wave4"></div>
        </div>
        <ul className="social_icons">
            <div><h4>PRESENTED BY DEVELOPERS CLUB (UIT)</h4></div>
        
          <li> <h5>RIYA KUSHWAHA </h5>   <a href="https://www.linkedin.com/in/riya-kushwaha-885853289/"><ion-icon name="logo-linkedin">
            </ion-icon></a> Riyakush0611@gmail.com <ion-icon name="mail-outline"></ion-icon></li>
          <li><h5>KANAK TIWARI </h5><a href="https://www.linkedin.com/in/kanak-tiwari-7964b822b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><ion-icon name="logo-linkedin"></ion-icon>
          </a> kanaktiwari2626@gmail.com <ion-icon name="mail-outline"></ion-icon></li>
        
        </ul>
      </footer>
      <script type="module" src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js"></script>
      <script nomodule src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js"></script>
    </div>
  );
}

export default Footer;